"use client";

import { Component, type ReactNode } from "react";
import * as Sentry from "@sentry/nextjs";

interface Props {
  fallback: ReactNode;
  children: ReactNode;
  boundary?: string;
}

interface State {
  hasError: boolean;
}

export class MapErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack?: string }) {
    Sentry.captureException(error, {
      tags: {
        boundary: this.props.boundary ?? "map",
        source: "google-maps",
      },
      level: "warning",
      contexts: {
        react: { componentStack: errorInfo.componentStack ?? "" },
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
